import React from 'react';
import { formatNumber } from 'humanize-plus';
import { titleize } from 'inflection';

import styles from './ideaUpdateItemStyles';

import Link from 'buyside/components/presentation/Link/link';

import FileTextIcon from 'buyside/svgs/document/file-text.svg';
import PaperStackIcon from 'buyside/svgs/paper_stack.svg';
import RightArrow from 'buyside/svgs/right_arrow.svg';
import TargetIcon from 'buyside/svgs/target.svg';
import ThermometerIcon from 'buyside/svgs/thermometer.svg';
import ClockIcon from 'buyside/svgs/clock.svg';
import LightningIcon from 'buyside/svgs/lightning_bolt_vertical.svg';
import ChannelCheckIcon from 'buyside/svgs/channel_check.svg';

import { ideaAttachmentUrl } from 'buyside/util/urlHelper';

const IdeaUpdateItem = ({ item, type, showAttachments, isCurrencySubunit = false }) => {
  let infoTitle = '';
  let description = '';
  let icon = <FileTextIcon className={styles.icon} />;
  switch (type) {
    case 'attachment':
      infoTitle = item.researchType;
      description = item.filename;
      if (item.researchType === 'Secondary Research') {
        icon = <PaperStackIcon className={styles.icon} />;
      } else if (item.researchType === 'Channel Check') {
        icon = <ChannelCheckIcon className={styles.icon} />;
      }
      break;
    case 'priceTarget':
      infoTitle = 'Target Price';
      const removedItem = isCurrencySubunit ? item.removed * 100 : item.removed;
      const addedItem = isCurrencySubunit ? item.added * 100 : item.added;
      description = (
        <span>
          {formatNumber(removedItem, 2)}
          <RightArrow className={styles.arrowIcon} />
          <span className={removedItem > addedItem ? styles.lesser : styles.greater}>
            {formatNumber(addedItem, 2)}
          </span>
        </span>
      );
      break;
    case 'returnTarget':
      infoTitle = 'Target Return';
      description = (
        <span>
          {item.removed}%
          <RightArrow className={styles.arrowIcon} />
          <span className={item.removed > item.added ? styles.lesser : styles.greater}>
            {item.added}%
          </span>
        </span>
      );
      break;
    case 'targetAllocation':
      infoTitle = 'Target Allocation';
      description = (
        <span>
          {item.removed}
          <RightArrow className={styles.arrowIcon} />
          {item.added}
        </span>
      );
      break;
    case 'situation':
      infoTitle = 'Situation';
      description = (
        <span>
          {titleize(item.removed)}
          <RightArrow className={styles.arrowIcon} />
          {titleize(item.added)}
        </span>
      );
      icon = <ThermometerIcon className={styles.icon} />;
      break;
    case 'timeframe':
      infoTitle = 'Timeframe';
      const timeframeMapping = {
        '< 3 Months': 1,
        '3-6 Months': 2,
        '6 Mo. - 1 Year': 3,
        '1-2 Years': 4,
        '2-5 Years': 5,
        '2+ Years': 5
      };
      let updatedItemClassName = '';
      if (timeframeMapping[item.added] > timeframeMapping[item.removed]) {
        updatedItemClassName = styles.greater;
      } else if (timeframeMapping[item.added] < timeframeMapping[item.removed]) {
        updatedItemClassName = styles.lesser;
      }
      description = (
        <span>
          {titleize(item.removed)}
          <RightArrow className={styles.arrowIcon} />
          <span className={updatedItemClassName}>{titleize(item.added)}</span>
        </span>
      );
      icon = <ClockIcon className={styles.icon} />;
      break;
    case 'catalyst':
      infoTitle = 'Catalysts';
      icon = <LightningIcon className={styles.icon} />;
      const addedCatalysts = item.added
        ? item.added.map(catalyst => ({ name: catalyst, added: true }))
        : [];
      const removedCatalysts = item.removed
        ? item.removed.map(catalyst => ({ name: catalyst, added: false }))
        : [];
      const combinedCatalysts = addedCatalysts.concat(removedCatalysts);
      description = combinedCatalysts.map((catalyst, idx) => (
        <span key={idx} className={catalyst.added ? styles.added : styles.removed}>
          <span className={!catalyst.added ? styles.strikethrough : ''}>
            {catalyst.added ? '+ ' : ''}
            {catalyst.name}
          </span>
          {
            <span className={styles.comma}>
              {combinedCatalysts.length > 1 &&
                ((combinedCatalysts.length - 2 === idx && ' and, ') ||
                  (combinedCatalysts.length - 1 !== idx && ', '))}
            </span>
          }
        </span>
      ));
      break;
  }
  if (type === 'priceTarget' || type === 'returnTarget' || type === 'targetAllocation') {
    icon = <TargetIcon className={styles.icon} />;
  }
  return (
    <div className={styles.ideaUpdateItem}>
      {icon}
      <div className={styles.infoArea}>
        <div className={styles.infoTitle}>{infoTitle}</div>
        {type === 'attachment' ? (
          showAttachments ? (
            <Link to={ideaAttachmentUrl(item.id)} className={styles.attachmentLink}>
              {description}
            </Link>
          ) : (
            <div className={styles.noAttachmentView}>Attachment unavailable</div>
          )
        ) : (
          <div className={styles.infoDescription}>{description}</div>
        )}
      </div>
    </div>
  );
};

export default IdeaUpdateItem;
